module.exports = __webpack_public_path__ + "img/colors-icon.48a0fb11.png";